const ReactTableCell = ({ cell, isCellExpanded, editing }: any) => {
  return (
    <td
      {...cell.getCellProps()}
      className={isCellExpanded ? "expanded__cell" : undefined}
      style={{ paddingRight: "0.5em" }}
    >
      {editing ? (
        <input value={cell.value} />
      ) : (
        cell.render("Cell", { isCellExpanded: isCellExpanded })
      )}
    </td>
  );
};

export default ReactTableCell;
